import { Action, State, StateContext } from '@ngxs/store';
import { CloseModal, OpenModal } from './actions/modal.actions';
import { ComponentType } from '@angular/cdk/overlay';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { inject, Injectable } from '@angular/core';
import { DialogRefConfig } from '@bioreferencehealth/ui-kit';
import { SafeDialogService } from 'src/app/services/safe-dialog.service';

export interface ModalStateModel {
  component?: ComponentType<unknown>;
  config?: DialogRefConfig;
}

@UntilDestroy()
@Injectable()
@State<ModalStateModel>({
  name: 'modal'
})
export class ModalState {
  private readonly safeDialogService = inject(SafeDialogService);

  @Action(OpenModal)
  public openModal(ctx: StateContext<ModalStateModel>, action: OpenModal<unknown>): void {
    this.safeDialogService
      .open(action.component, action.config)
      .afterClosed()
      .pipe(untilDestroyed(this))
      .subscribe(() => {
        ctx.dispatch(new CloseModal(action.component));
      });
  }
}
